import EarnLogo from '@assets/icons/earn.svg'
import { SidebarMobileToggle } from '@components/Sidebar/MobileToggle'
import LiquidiumLogo from '@plug-core/assets/icons/liquidium.png'
import OneSecLogo from '@plug-core/assets/icons/onesec.png'
import TCyclesLogo from '@plug-core/assets/icons/tcycles.png'
import WaterNeuronLogo from '@plug-core/assets/icons/waterneuron.png'
import {
  BTC_ID,
  CKBTC_ICP_ID,
  ODINBTC_ID,
  USDC_BASE_ID,
  USDC_ICP_ID,
} from '@plug-core/constants/tokenIds'
import { Chain } from '@plug-core/interfaces/common'
import { getChainIcon } from '@plug-core/utils/getChainIcon'
import { ListGroup, ListRow, RowTile } from '@ui'
import { ROUTES } from '@utils/routes'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

interface DeFiHubItem {
  image: string
  primaryText: string
  secondaryText: string
  route: string
  navState?: unknown
}

export const DeFiHub = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const list: DeFiHubItem[] = [
    {
      image: 'https://plug-cdn.s3.amazonaws.com/chain-logos/hyperliquid.png',
      primaryText: t('defi.perps.title'),
      secondaryText: t('defi.perps.description'),
      route: ROUTES.PERPS,
    },
    {
      image: EarnLogo,
      primaryText: t('defi.earn.title'),
      secondaryText: t('defi.earn.description'),
      route: ROUTES.EARN,
    },
    {
      image: LiquidiumLogo,
      primaryText: t('defi.liquidium.title'),
      secondaryText: t('defi.liquidium.description'),
      route: ROUTES.BORROW_LEND,
    },
    {
      image: WaterNeuronLogo,
      primaryText: t('defi.stake.title'),
      secondaryText: t('defi.stake.description'),
      route: ROUTES.STAKE,
    },
    {
      image: OneSecLogo,
      primaryText: t('defi.onesec.title'),
      secondaryText: t('defi.onesec.description'),
      route: ROUTES.SWAP,
      navState: { fromTokenId: USDC_ICP_ID, toTokenId: USDC_BASE_ID },
    },
    {
      image: getChainIcon(Chain.ODIN),
      primaryText: t('defi.odin.title'),
      secondaryText: t('defi.odin.description'),
      route: ROUTES.SWAP,
      navState: { fromTokenId: CKBTC_ICP_ID, toTokenId: ODINBTC_ID },
    },
    {
      image: 'https://plug-cdn.s3.amazonaws.com/ckbtc.png',
      primaryText: t('defi.mint.title'),
      secondaryText: t('defi.mint.description'),
      route: ROUTES.SWAP,
      navState: { fromTokenId: BTC_ID, toTokenId: CKBTC_ICP_ID },
    },
    {
      image: TCyclesLogo,
      primaryText: t('defi.topup.title'),
      secondaryText: t('defi.topup.description'),
      route: ROUTES.TOPUP,
    },
  ]

  return (
    <div className="mb-3 flex flex-col gap-3">
      <SidebarMobileToggle title="DeFi Hub" />
      <ListGroup>
        {list.map((item) => (
          <ListRow
            key={item.primaryText}
            leading={
              <RowTile>
                <img src={item.image} alt="" />
              </RowTile>
            }
            primary={item.primaryText}
            secondary={item.secondaryText}
            chevron
            onClick={() => navigate(item.route, { state: item.navState })}
          />
        ))}
      </ListGroup>
    </div>
  )
}
